import Map from './Map'

/**
 * @see http://download.oracle.com/javase/6/docs/api/java/util/SortedMap.html
 */
export default class SortedMap extends Map {}
